import Typography from '@material-ui/core/Typography';

export function CorridorName({ className, name }: Props) {
  return <Typography classes={{ root: className }}>{name}</Typography>;
}
interface Props {
  className: string;
  name: string | undefined;
}
